module.exports = __webpack_public_path__ + "assets/img/driver-btn-7c4cd47a.png";